// extracted by mini-css-extract-plugin
module.exports = {"logo":"_404__logo___1_Nqx","whatIsThis":"_404__whatIsThis___6NXbp"};